import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
const assurances = ['Accesso digitale in PDF', 'Pagamento unico', 'Tutto in italiano'];
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-16 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-111" data-mp="12mr2t9xjd489">
      <div className="mx-auto max-w-4xl text-center" data-id="element-112" data-mp="1zbys8t19zxhg">
        <p className="inline-flex items-center rounded-[8px] border border-brand-champagne/50 bg-brand-ivory px-4 py-2 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/75 sm:text-[11px]" data-id="element-113" data-mp="1zbfgxv64s7ce">
          Per formatrici Lash & Brow
        </p>

        <h1 className="mt-6 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-114" data-mp="1lbe73q7w1pks">
          Prepara le tue lezioni Lash & Brow in <Accent data-id="element-115" data-mp="9w91oegdhcxh">pochi minuti</Accent>, non in ore!
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-116" data-mp="38gbg6norb83v">
          Il sistema didattico pronto all'uso per formatrici di ciglia e sopracciglia che vogliono
          insegnare con più metodo e meno preparazione.
        </p>
      </div>

      <img src={MOCKUP_URL} alt="Lash & Brow Instructor Ready — Versione Italiana: i sei volumi, con il Volume 1 al centro" width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain lg:max-w-[900px]" style={{
      filter: 'drop-shadow(0 34px 40px rgba(180, 86, 111, 0.18))'
    }} data-id="element-117" data-mp="34epxglpjjzlr" />

      <div className="mx-auto mt-8 max-w-2xl text-center" data-id="element-118" data-mp="2kqh5abnzztm9">
        <p className="text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-119" data-mp="2kr0caxc40xli">
          Smetti di creare ogni lezione da zero!
        </p>
        <p className="mt-3 text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-120" data-mp="2bqc1sclxdfdd">
          Con Lash & Brow Instructor Ready™ hai{' '}
          <strong className="font-semibold text-brand-charcoal" data-id="element-121" data-mp="hbybt0umv2ie">6 volumi + 5 bonus didattici</strong> con
          tecniche professionali, lezioni strutturate, esercizi per le allieve e strumenti di valutazione.
        </p>
        <p className="mt-3 text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-122" data-mp="3ip89gtd9b7s">
          Tutto in italiano, organizzato per aiutarti a preparare i tuoi corsi più velocemente.
        </p>
      </div>

      <CtaBlock label="Voglio le mie lezioni pronte!" className="mt-9" data-id="element-123" data-mp="w6l0o9bwkgyr" />

      <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-124" data-mp="r81ec7ted35v">
        {assurances.map(item => <li key={item} className="flex items-center gap-1.5 font-body text-[12px] text-brand-charcoal/60" data-id="element-125" data-mp="m9ghmidct1m6">
            <CheckIcon className="h-3.5 w-3.5 text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-126" data-mp="3byinlsbyogn9" />
            {item}
          </li>)}
      </ul>
    </section>;
}